module.exports = __webpack_public_path__ + "img/3.f3f182c8.jpg";